module.exports = __webpack_public_path__ + "img/dfki.ef9c3de8.svg";